import { DropTarget } from './utils';
import { DnDContext } from './getDnDContext';

export const getSwapDropTarget = (dndContext: NonNullable<DnDContext>) => {
  const {
    dropTargets,
    rowCount,
    deltaY,
    eventPosition: { currentX: eventCurrentX, currentY: eventCurrentY },
  } = dndContext;

  if (dropTargets.length === 0) return null;
  if (dropTargets.length === 1) return dropTargets[0];
  if (rowCount === 1) return getSwapTargetOfRow(dropTargets, eventCurrentX);

  const first = dropTargets[0];
  const last = dropTargets[dropTargets.length - 1];
  if (eventCurrentY + deltaY / 2 < first.currentY) return first;
  if (eventCurrentY - deltaY / 2 > last.currentY + last.box.height) return last;

  const activeRow = dropTargets.filter(
    ({ currentY, box: { height } }) =>
      currentY - deltaY / 2 < eventCurrentY &&
      eventCurrentY < currentY + height + deltaY / 2
  );

  return getSwapTargetOfRow(activeRow, eventCurrentX);
};

const getSwapTargetOfRow = (
  dropTargets: DropTarget[],
  eventCurrentX: number
) => {
  return dropTargets.find((dropTarget, index) => {
    if (dropTarget.isDragTarget) return false;
    if (dropTargets.length === 1) return true;
    const isFirst = index === 0;
    const isLast = index === dropTargets.length - 1;
    if (isFirst) {
      return eventCurrentX < getDropCenterX(dropTarget);
    }
    const previous = dropTargets[index - 1];
    if (previous.isDragTarget)
      return eventCurrentX > getDropCenterX(dropTarget);

    return (
      getDropCenterX(previous) < eventCurrentX &&
      (isLast || eventCurrentX < getDropCenterX(dropTarget))
    );
  });
};

const getDropCenterX = ({ currentX, box: { width } }: DropTarget) =>
  currentX + width / 2;
